/*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho TH là
 * `src/components-v2/organisms/pages/landingPageThai/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản TH (viền + nền nhạt, có nút "..." gom tag dư, có ngày
 * cận date) nên hợp nhất là thay đổi design, cần sign-off — xem docs/product-tag-display-spec.md.
 *
 * Đừng thêm rule mới vào đây.
 */
import TagTypeProps from 'constants/TagTypeProps';
import { useAuth } from 'context';
import { useTranslation } from 'next-i18next';
import { REGION_MB, TAG_HANG_DAT_TRUOC, TAG_NEW } from 'sysconfig';
import { DateTimeUtils } from 'utils';
import { useStore } from 'zustand-lib/storeGlobal';
import ProductTag from '../ProductTag';

export const tagTypePropsArr = [
  'OUT_OF_STOCK',
  'SUSPENDED',
  'GIFT',
  'FLASH_SALE',
  'MEGA_DAY',
  'DEAL',
  TAG_HANG_DAT_TRUOC,
  'FV2U',
  '2ABC',
  'HOADONNHANH',
  'BAN_CHAY',
  'BANCHAY',
  'Y7GB',
  '84AB',
  '3ABC',
];
const tagIconArr = ['GIAONHANH', 'W80T', 'BAN_CHAY', 'BANCHAY', 'HOADONNHANH'];
const tagNoDisplayArr = [TAG_NEW];

export const getTagName = (item, getStyleBySlugOfTag) => {
  if (item === 'NEAR_EXPIRATION') {
    return 'Cận date';
  }
  if (tagNoDisplayArr?.indexOf(item) >= 0) {
    return null;
  }
  const tagInfo = TagTypeProps[item];
  if (tagInfo?.name) {
    return tagInfo.name;
  }
  return getStyleBySlugOfTag(item)?.name || '';
};

// notes
// cận date chưa làm ,  nếu có status cận date
// khuyến mãi , nếu có deal tự thêm mã giảm giá vào tag
// nên chuyển về 1 cái , làm sau
const TagType = ({ item, exp, isTooltip = false, isDisplayFull = false, link, isLinkTagDeal }) => {
  const { t: translateCommon } = useTranslation('common');
  const getStyleBySlugOfTag = useStore((state) => state.getStyleBySlugOfTag);
  const { customerInfo } = useAuth();

  let props = {};
  if (item === TAG_HANG_DAT_TRUOC && REGION_MB.indexOf(`${customerInfo?.provinceCode}`) < 0) {
    return null;
  }
  if (item === 'NEAR_EXPIRATION') {
    const date = DateTimeUtils.getFormattedDate(new Date(exp), 'DD-MM-YYYY');
    const { code, textColor, backgroundColor, url } = TagTypeProps.NEAR_EXPIRATION;
    props = {
      name: `${translateCommon('tag.NEAR_EXPIRATION')} ${date}`,
      date,
      code,
      textColor,
      backgroundColor,
      url,
    };
  } else if (!isDisplayFull && tagNoDisplayArr?.indexOf(item) >= 0) {
    return null;
  } else {
    // nếu ko có option nào thì lấy theo API trả về
    const tagInfo = TagTypeProps[item];
    props = tagInfo ? { ...tagInfo, isTooltip } : getStyleBySlugOfTag(item);
    if (props && !props?.name) {
      props.name = getStyleBySlugOfTag(item)?.name || '';
    }
    if (props && !props?.slug) {
      props.slug = getStyleBySlugOfTag(item)?.slug || '';
    }
    if (!props) {
      return null;
    }
    if (tagIconArr?.indexOf(item) >= 0) {
      props = { ...props, isTooltip };
    }
  }
  // translate tag số lượng có hạn
  if (item === 'LIMIT') {
    props.name = translateCommon('tag.LIMIT');
  }

  return <ProductTag link={link} isLinkTagDeal={isLinkTagDeal} {...props} />;
};

export default TagType;
